import { render, staticRenderFns } from "./PermintaanData.vue?vue&type=template&id=c83e3654&"
import script from "./PermintaanData.vue?vue&type=script&lang=js&"
export * from "./PermintaanData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports